import Awesomplete from 'awesomplete';

const init = function () {
  if (document.getElementById("foaId")) {
    let foaInput = document.getElementById("foaId");
    new Awesomplete(foaInput, {
      list: [
        "Frau",
        "Herr",
        "Mrs",
        "Mr",
        "Dr.",
        "Herr Dr.",
        "Frau Dr.",
        "Dr",
        "Mr Dr",
        "Mrs Dr",
        "Prof. Dr.",
        "Herr Prof. Dr.",
        "Frau Prof. Dr.",
        "Professor Dr",
        "Mr Professor Dr",
        "Mrs Professor Dr",
      ],
    });
  }
};
document.addEventListener("DOMContentLoaded", init, false);
